import './style.css';
import { initReveal } from './animations/reveal';
import { initNav } from './animations/nav';
import { initTree } from './animations/tree';
import { initTreeRotator } from './animations/tree-rotator';
import { initContactForm } from './form/contact';
import { initTestimonials } from './animations/testimonials';

/**
 * Entry point. Every piece of content lives in static HTML; this bundle only
 * progressively enhances the already-complete page with animation and form
 * feedback. If it never runs, the site remains fully readable and functional.
 */

// Marks that JS is active. The `.js-enabled` class gates the hidden starting
// states for reveals and the tree draw (also set inline in <head> to avoid a
// flash before this module executes).
document.documentElement.classList.add('js-enabled');

function start(): void {
  initNav();
  initReveal();
  initTree();
  initTreeRotator();
  initContactForm();
  initTestimonials();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
